// extracted by mini-css-extract-plugin
module.exports = {"colFile":"FileList_colFile__1c7Gb","rowFile":"FileList_rowFile__1XUas","removeBtn":"FileList_removeBtn__mrWar"};